import Vue from 'vue'
import VtCloneToggle from '@/components/common/VtCloneToggle.vue'
Vue.component('VtCloneToggle', VtCloneToggle)
